// extracted by mini-css-extract-plugin
export var accordion = "_du-0";
export var chevron = "_du-3";
export var closed = "_du-2";
export var content = "_du-4";
export var open = "_du-1";
export var rotate = "_du-5";